export const EVENTS = {
  "pix-generated": 1,
  "pix-expired": 2,
  payed: 3,
  renewal: 4,
  header: 5,
  "pricing-panel-annual-cta": 6,
  "reviews-cta": 7,
  "comparison-annual-cta": 8,
  "features-cta": 9,
  "end-of-page-cta": 10,
  "profile-cta": 11,
  "rewrite-cta": 12,
  "rewrite-texts-cta": 13,
  "summarize-cta": 14,
  "rewrite-texts-banner": 15,
  "summarize-banner": 16,
  "hamburger-menu-cta": 17,
  "footer-cta": 18,
  "home-tools-cta": 19,
  "home-checklist-cta": 20,
  "home-testimonials-cta": 21,
  "home-tools-register-cta": 22,
  "home-checklist-register-cta": 23,
  "home-testimonials-register-cta": 24,
  cta_pro_click_reescrever_popup_max_usage: 25,
  cta_pro_click_reescrever_editor_max_usage: 26,
  cta_pro_click_reescrever_editor_max_characters: 27,
  cta_pro_click_reescrever_popup_feat_pro: 28,
  cta_pro_click_reescrever_top_banner: 29,
  cta_pro_click_detector_ia_top_banner: 30,
  cta_pro_click_detector_ia_popup_max_usage: 31,
  cta_pro_click_detector_ia_editor_max_usage: 32,
  cta_pro_click_detector_ia_editor_max_characters: 33,
  cta_pro_click_humanizador_top_banner: 34,
  cta_pro_click_humanizador_popup_max_usage: 35,
  cta_pro_click_humanizador_editor_max_usage: 36,
  cta_pro_click_humanizador_editor_max_characters: 37,
  cta_pro_click_resumir_top_banner: 38,
  cta_pro_click_resumir_editor_max_usage: 39,
  cta_pro_click_corrigir_top_banner: 40,
  "stripe-generated": 41,
  "stripe-expired": 42,
  cta_pro_click_reescrever_com_sinonimos_popup_max_usage: 43,
  cta_pro_click_reescrever_com_sinonimos_editor_max_usage: 44,
  cta_pro_click_reescrever_com_sinonimos_editor_max_characters: 45,
  cta_pro_click_reescrever_com_sinonimos_popup_feat_pro: 46,
  cta_pro_click_reescrever_com_sinonimos_top_banner: 47,
  "payment-data-fill": 48,
  "banner-renew-PIX": 49,
  "popup-renew-PIX": 50,
};
